import { useScrollReveal } from '@/hooks/useScrollReveal';

const rows = [
  { label: 'Оплата', old: 'Оплата за клики, показы и работу подрядчика', new: 'Оплата за согласованный результат' },
  { label: 'Скорость ответа', old: 'Клиент может не дождаться ответа', new: 'ИИ отвечает сразу' },
  { label: 'Качество', old: 'Менеджер тратит время на нецелевые обращения', new: 'ИИ квалифицирует запрос' },
  { label: 'Удержание', old: 'Клиент может забыть о заявке', new: 'ИИ делает аккуратное напоминание' },
  { label: 'Данные', old: 'В CRM попадает только номер', new: 'Передаётся контакт и история диалога' },
];

export default function LTKComparison() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: tableRef, revealed: tableRevealed } = useScrollReveal({ delay: 200 });

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Сравнение
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Почему это выгоднее обычной рекламы
          </h2>
        </div>

        <div ref={tableRef} className={`max-w-3xl mx-auto reveal-fade-up ${tableRevealed ? 'revealed' : ''}`}>
          <div className="rounded-2xl border border-background-200/70 bg-background-50 overflow-x-auto">
            <div className="min-w-[560px]">
            <div className="grid grid-cols-[1fr_1fr_1fr] px-4 md:px-6 py-4 bg-background-100 border-b border-background-200/70">
              <span className="text-[12px] md:text-[13px] font-semibold text-foreground-700 uppercase tracking-wide">&nbsp;</span>
              <span className="text-[12px] md:text-[13px] font-semibold text-foreground-500 uppercase tracking-wide">Обычная реклама</span>
              <span className="text-[12px] md:text-[13px] font-semibold text-primary-600 uppercase tracking-wide">Наша система</span>
            </div>

            {rows.map((row, i) => (
              <div
                key={row.label}
                className={`grid grid-cols-[1fr_1fr_1fr] px-4 md:px-6 py-4 items-start ${
                  i < rows.length - 1 ? 'border-b border-background-200/40' : ''
                } hover:bg-background-100 transition-colors`}
              >
                <span className="text-[12px] md:text-[13px] font-medium text-foreground-500 pt-0.5">{row.label}</span>
                <div className="flex items-start gap-1.5 md:gap-2 pr-3 md:pr-4">
                  <span className="w-5 h-5 rounded-full bg-secondary-100 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-close-line text-secondary-500 text-xs"></i>
                  </span>
                  <span className="text-[13px] md:text-[14px] text-foreground-600">{row.old}</span>
                </div>
                <div className="flex items-start gap-1.5 md:gap-2">
                  <span className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary-500 text-xs"></i>
                  </span>
                  <span className="text-[13px] md:text-[14px] text-foreground-900 font-medium">{row.new}</span>
                </div>
              </div>
            ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}